var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuzuki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    viewBox: "0 0 951.1 951.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-87.778474,-79.89161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3213",
    d: "M1029.1,734.5c0,0-87.2,25.3-256.3,129.2 C621,957,561.5,1019.7,561.5,1019.7L93.7,696.4c0,0,196.8-144.7,361.3-33.9l220.6,151.3l26.9-17.7L93.7,369.8 c0,0,87.5-25.3,256.6-129.2C502.2,147.2,561.5,84.5,561.5,84.5l468,323.3c0,0-196.8,144.8-361.3,33.9L447.6,290.3L420.7,308 L1029.1,734.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuzuki);
export default __webpack_public_path__ + "static/media/suzuki.529ddf4c95397f9afafc6b7be4d2000a.svg";
export { ForwardRef as ReactComponent };